import {Location} from '@angular/common';
import {PermissionService} from '@shared/service/permission.service';
import {
	ROOT_ADMINISTRATION_CHANNELING,
	ROOT_ADMINISTRATION_RULES,
	ROOT_ADMINISTRATION_USER_MANAGEMENT,
	ROOT_AUTHORITY,
	ROOT_BOOKINGS_PRELEASE,
	ROOT_BOOKINGS_RELIEF,
	ROOT_CARGOS,
	ROOT_CLAIMS_ADMIN,
	ROOT_CLAIMS_APPROPRIATION,
	ROOT_CLAIMS_COMPLAINT,
	ROOT_CLAIMS_OLSA,
	ROOT_CLAIMS_PRACTICE_CAR,
	ROOT_CLAIMS_PRACTICES,
	ROOT_CLAIMS_REPAIR,
	ROOT_CLAIMS_SUPERVISOR,
	ROOT_CLAIMS_THEFT,
	ROOT_CONTRACT_CLOSING_ALD,
	ROOT_CONTRACT_CLOSING_DK_BO,
	ROOT_CONTRACT_CLOSING_DK_C,
	ROOT_CONTRACT_CLOSING_DK_OP,
	ROOT_CONTRACT_CLOSING_SP,
	ROOT_DELIVERY,
	ROOT_DELIVERY_ASR,
	ROOT_FLOTTA_POOL,
	ROOT_INVOICING,
	ROOT_LOGISTICS,
	ROOT_MOBILITY,
	ROOT_NOT_FOUND_PAGE,
	ROOT_NOTIFICATION_CENTER,
	ROOT_PROFILE,
	ROOT_TYRES,
	ROOT_USER_CHANGE_ALD,
	ROOT_USER_CHANGE_SP
} from '../../app-routing-roots';
import {NemoModuleKeys} from '@shared/models/user-permission.model';
import {AUTHORITY_APPOINTMENTS_LIST, AUTHORITY_DASHBOARD, AUTHORITY_DOSSIER_LIST} from '../../authority/authority-routing-roots';
import {INVOICING_DASHBOARD, INVOICING_INVOICES, INVOICING_TASKS} from '../../invoicing/invoicing-routing-roots';
import {TYRES_OPA, TYRES_OPC, TYRES_OPF, TYRES_OPS} from '../../tyres/tyres-routing-roots';
import {TYRES_OPC_CONTRACT_DETAIL, TYRES_OPC_CONTRACTS, TYRES_OPC_DASHBOARD} from '../../tyres/opc/tyres-opc-routing-roots';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {LOGISTICS_OPAD, LOGISTICS_OPASR, LOGISTICS_OPC, LOGISTICS_OPL} from '../../logistics/logistics-routing-roots';
import {CLAIMS_CUSTOM_ADMIN_PROFILES} from '../../permissions-variables';
import {UserV3Service} from '@shared/service/user-v-3.service';


export function is_valid_route(
	location: Location,
	permissionService: PermissionService,
): boolean {
	const
		module: string = location.path().split('/')[1],
		current_item_menu_id: string = get_current_item_menu_id(location, permissionService);

	let isValidRoute: boolean = true;
	switch (module) {
		case ROOT_AUTHORITY:
			/**
			 * Show the select center component only if the current route is enabled and it is a center operator
			 */
			isValidRoute = permissionService.getCurrentUserPermissions().isCenterOperator(NemoModuleKeys.AUTHORITY) && (
				location.path() === `/${ROOT_AUTHORITY}/${AUTHORITY_DASHBOARD}` ||
				location.path() === `/${ROOT_AUTHORITY}/${AUTHORITY_DASHBOARD}/${AUTHORITY_DOSSIER_LIST}` ||
				location.path() === `/${ROOT_AUTHORITY}/${AUTHORITY_DASHBOARD}/${AUTHORITY_APPOINTMENTS_LIST}`
			);
			break;
		case ROOT_INVOICING:
			isValidRoute = location.path() === `/${ROOT_INVOICING}/${INVOICING_DASHBOARD}` ||
				location.path() === `/${ROOT_INVOICING}/${INVOICING_TASKS}` ||
				location.path() === `/${ROOT_INVOICING}/${INVOICING_INVOICES}`;
			break;
		case ROOT_TYRES:
			const tyre_contract_detail: string = `/${ROOT_TYRES}/${TYRES_OPC}/${TYRES_OPC_DASHBOARD}/${TYRES_OPC_CONTRACTS}/${TYRES_OPC_CONTRACT_DETAIL}/`;
			isValidRoute = !(location.path().startsWith(tyre_contract_detail));
			break;
	}
	return !permissionService.getCommoditiesFromItemMenuID(current_item_menu_id) || !permissionService.getCommoditiesFromItemMenuID(current_item_menu_id).length || !isValidRoute;
}

export function get_current_item_menu_id(location: Location, permissionService: PermissionService): string {
	switch (true) {
		case location.path().startsWith('/' + ROOT_DELIVERY + '/'):
			return UserV3Model.DELIVERY_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_DELIVERY_ASR):
			return UserV3Model.DELIVERY_ASR_ITEM_MENU_ID;
		case location.path() === '/' + ROOT_PROFILE:
			return UserV3Model.PROFILE_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CONTRACT_CLOSING_SP):
			return UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CONTRACT_CLOSING_DK_C):
			return UserV3Model.CONTRACT_CLOSING_DK_C_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CONTRACT_CLOSING_DK_OP):
			return UserV3Model.CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CONTRACT_CLOSING_ALD):
			return UserV3Model.CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CONTRACT_CLOSING_DK_BO):
			return UserV3Model.CONTRACT_CLOSING_DK_BO_OP_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CLAIMS_ADMIN):
			if (permissionService.getCurrentUserPermissions().hasProfile(CLAIMS_CUSTOM_ADMIN_PROFILES)) {
				return UserV3Model.CLAIMS_CUSTOM_ADMIN_ITEM_MENU_ID;
			} else {
				return UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID;
			}
		case location.path().startsWith('/' + ROOT_CLAIMS_SUPERVISOR):
			return UserV3Model.CLAIMS_SUPERVISOR_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CLAIMS_OLSA):
			return UserV3Model.CLAIMS_OLSA_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CLAIMS_REPAIR):
			return UserV3Model.CLAIMS_REPAIR_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CLAIMS_APPROPRIATION):
			return UserV3Model.CLAIMS_APPROPRIATION_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CLAIMS_THEFT):
			return UserV3Model.CLAIMS_THEFT_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CLAIMS_PRACTICE_CAR):
			return UserV3Model.CLAIMS_PRACTICE_CAR_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CLAIMS_PRACTICES):
			return UserV3Model.CLAIMS_PRACTICES_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_CLAIMS_COMPLAINT):
			return UserV3Model.CLAIMS_COMPLAINT_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_NOTIFICATION_CENTER):
			return UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_TYRES + '/' + TYRES_OPC):
			return UserV3Model.TYRES_ITEM_OPC_MENU_ID;
		case location.path().startsWith('/' + ROOT_TYRES + '/' + TYRES_OPA):
			return UserV3Model.TYRES_ITEM_OPA_MENU_ID;
		case location.path().startsWith('/' + ROOT_TYRES + '/' + TYRES_OPF):
			return UserV3Model.TYRES_ITEM_OPF_MENU_ID;
		case location.path().startsWith('/' + ROOT_TYRES + '/' + TYRES_OPS):
			return UserV3Model.TYRES_ITEM_OPS_MENU_ID;
		case location.path().startsWith('/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPL):
			return UserV3Model.LOGISTICS_ITEM_OPL_MENU_ID;
		case location.path().startsWith('/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPC):
			return UserV3Model.LOGISTICS_ITEM_OPC_MENU_ID;
		case location.path().startsWith('/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPAD):
			return UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID;
		case location.path().startsWith('/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPASR):
			return UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID;
		case location.path().startsWith('/' + ROOT_USER_CHANGE_SP):
			return UserV3Model.USER_CHANGE_SP_MENU_ID;
		case location.path().startsWith('/' + ROOT_USER_CHANGE_ALD):
			return UserV3Model.USER_CHANGE_ALD_MENU_ID;
		case location.path().startsWith('/' + ROOT_NOT_FOUND_PAGE):
			return UserV3Model.NOT_FOUND_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_AUTHORITY):
			return UserV3Model.AUTHORITY_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_MOBILITY):
			return UserV3Model.MOBILITY_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_INVOICING):
			return UserV3Model.INVOICING_ITEM_MENU_ID;
		case location.path().startsWith('/' + ROOT_ADMINISTRATION_RULES):
			return UserV3Model.ADMINISTRATION_RULES_MENU_ID;
		case location.path().startsWith('/' + ROOT_ADMINISTRATION_CHANNELING):
			return UserV3Model.ADMINISTRATION_CHANNELING_MENU_ID;
		case location.path().startsWith('/' + ROOT_ADMINISTRATION_USER_MANAGEMENT):
			return UserV3Model.ADMINISTRATION_USERS_MENU_ID;
		case location.path().startsWith('/' + ROOT_FLOTTA_POOL):
			return UserV3Model.FLOTTA_POOL_MENU_ID;
		case location.path().startsWith('/' + ROOT_BOOKINGS_RELIEF):
			return UserV3Model.BOOKINGS_RELIEF_MENU_ID;
		case location.path().startsWith('/' + ROOT_BOOKINGS_PRELEASE):
			return UserV3Model.BOOKINGS_PRELEASE_MENU_ID;
		case location.path().startsWith('/' + ROOT_CARGOS):
			return UserV3Model.CARGOS_ITEM_MENU_ID;
			
		default:
			return '-1';
	}
}

export function isSuperUser(userV3Service: UserV3Service, superUserList: string[]): boolean {

	return superUserList && superUserList.includes( userV3Service.getCurrentUser().id );
}

export async function sleep(seconds: number): Promise<any> {
	return new Promise(res => setTimeout(() => res(null) , seconds));
}

String.prototype.printf = function(...params: any[]): string {

	if (!this)
		return '';

	if (!params.length)
		return this;
	
	const CHAR_LIST = ['%s', '%d', '%o'];

	let copy = this;
	for (let i=0, j=0, x=0, n=this.length; i<n; i++, j++) {

		// i => this counter
		// j => copy counter
		// x => params counter

		// Trovare uno dei caratteri speciali
		if (this[i] === '%' && CHAR_LIST.includes( this.slice(i, i+2) )) {

			// TODO ? - controllare match del tipo tra parametri e %s-%d-%o

			const par = typeof params[x] === 'object' ? JSON.stringify(params[x]) : params[x].toString();
			copy = copy.slice(0, j) + par + this.slice(i+2, n);
			
			// allinamento copy con str
			j += par.length-1;
			i++;
			x++;
		}
	}	
	return copy;
}

export function getURLPath(): string {
	const pivot = '/#/';
	const url = document.URL;
	return url.substring(url.indexOf('/#/')+pivot.length, url.length);
}

/**
 * Verifica se il sinistro è migrato da LeasePlan (LP).
 * Restituisce true se il practice_id è compreso tra 2 e 3 miliardi.
 */
export function isMigratedFromLP(practice_id: number): boolean {
    return practice_id >= 2_000_000_000 && practice_id <= 3_000_000_000;
}

/**
 * Verifica se la riparazione è LP e non creata su Nemo Authority.
 * Restituisce true se authority_working_id inizia con 'LP' e NON con 'NEC', 'NEM', 'NEG'.
 */
export function isRepairLP(authority_working_id: string): boolean {
    if (!authority_working_id) return false;
    const upperId = authority_working_id.toUpperCase();
    return upperId.startsWith('LP')
}
